exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ll-billed-status-select[data-v-1323cec7] .v-autocomplete .v-autocomplete__selection-text {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n", ""]);

// exports
